export const destinations: { [key: string]: string | undefined } = {
  moreThanCar: process.env.GATSBY_DESTINATION_MORE_THAN_CAR,

  moreThanHome: process.env.GATSBY_DESTINATION_MORE_THAN_HOME,

  moreThanPet: process.env.GATSBY_DESTINATION_MORE_THAN_PET,
};

export type DestinationKey = keyof typeof destinations;
